import { Dispatch, SetStateAction, useContext } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Logo from '../../../../../common/assets/images/Logo-Benefit-Edenred.svg';
import useBreakpoints from '../../../../../common/hooks/useBreakpoints';
import Icons from '../../../../../common/widgets/Icons';
import { CustomerInfoContext } from '../../../contexts/CustomerInfoContext';
import Search from '../../../widgets/Search';
import Account from './menuItems/AccountMenuItem';
import Cart from './menuItems/CartMenuItem';
import Favorite from './menuItems/FavoriteMenuItem';
import Help from './menuItems/HelpMenuItem';
import Language from './menuItems/LanguageMenuItem';

interface IAppBarProps {
  onMenuClick: Dispatch<SetStateAction<boolean>>;
  isMenuOpen: boolean;
}

export default function AppBar(props: Readonly<IAppBarProps>) {
  const navigate = useNavigate();
  const location = useLocation();

  const { isTablet } = useBreakpoints();
  const { onMenuClick, isMenuOpen } = props;

  const { customerInfo } = useContext(CustomerInfoContext);

  const isHomePage = location.pathname === '/';
  const isSearchPage = location.pathname === '/products/search';

  const renderMobileNavToggle = () => {
    if (customerInfo.isSavingsUser && !isHomePage) {
      return (
        <button
          type="button"
          className="app-bar-mobile-nav"
          onClick={() => navigate(location.pathname === '/not-found' ? -2 : -1)}
        >
          <Icons.ChevronLeft />
        </button>
      );
    }

    if (!isMenuOpen) {
      return (
        <button
          type="button"
          className="app-bar-mobile-nav"
          style={{ display: 'none' }}
          onClick={() => onMenuClick(prev => !prev)}
        >
          <Icons.Menu />
        </button>
      );
    }

    return (
      <button
        type="button"
        className="mobile-nav-close"
        onClick={() => onMenuClick(false)}
      >
        <Icons.CloseDelete />
      </button>
    );
  };

  return (
    <header
      className={`app-bar ${
        isTablet && isSearchPage ? 'app-bar-search-page' : ''
      }`.trim()}
    >
      <div
        className={`container ${
          customerInfo.isSavingsUser ? 'app-bar-no-logo' : ''
        }`.trim()}
      >
        {isTablet && !isSearchPage && renderMobileNavToggle()}
        {!customerInfo.isSavingsUser && !(isTablet && isSearchPage) && (
          <div className="app-bar-branding">
            <Link to="/">
              <img src={Logo} alt="Logo Benefit Edenred" />
            </Link>
          </div>
        )}

        {!isTablet && <Search />}

        {isTablet && isSearchPage && (
          <div className="app-bar-mobile-search">
            <Search />
          </div>
        )}

        {/* Tools desktop */}
        {!isTablet && (
          <div className="app-bar-tools">
            <Language />
            <Account isTablet={isTablet} />
            <Help />
            <Favorite />
            <Cart isTablet={isTablet} />
          </div>
        )}

        {/* Search and tools mobile */}
        {isTablet && !isSearchPage && (
          <div className="app-bar-tools-mobile">
            {isTablet && (
              <a className="btn app-bar-tools-btn app-bar-search-m">
                <span
                  className="btn-icon"
                  onClick={() => navigate('/products/search')}
                >
                  <Icons.SearchNormal />
                </span>
              </a>
            )}
            <Cart isTablet={isTablet} />
          </div>
        )}
      </div>
    </header>
  );
}
